<template>
  <section :class="`c-form-input-item`" class="c-form-item">
    <label>{{ label }}</label>

    <!-- 普通文本输入框 -->
    <div class="input-wrap">
      {{ value }}
    </div>
  </section>
</template>

<script>
  export default {
    name: 'FormReadItem',
    props: {
      value: { type: String, default: '' },
      label: { type: String, required: true },
    },
  }
</script>

<style lang="less" scoped>
@import url("./formItem.less");

.c-form-input-item {
  .input-wrap {
    input {
      font-size: 30px;
      padding: 0;
      width: 100%;
      background-color: transparent;

      &[readonly] {
        color: #999;
        cursor: not-allowed;
      }
    }
  }
}

</style>
